<template>
  <div class="CourseUnitModel">
    <div class="menuListBox" :class="{'menuListBoxActive':menuStatus}">
      <div class="operateBox" style="display:flex;align-items: center;justify-content: space-between;height:60px">
        <p class="courseTitle">科目信息</p>
        <div class="operateList" style="margin:0" @click="menuStatus=false"> <a-tooltip placement="bottom" title="隐藏侧栏"><i class="iconfont" style="font-size:20px">&#xe630;</i></a-tooltip></div>
      </div>
      <div class="menuList">
          <a-tree :default-expanded-keys="defaultExpandedKeys" :expanded-keys="expandedKeys">
              <a-tree-node v-for="item in treeData" :key="item.id" >
                <span slot="title" @click="onSelect(item.id)" class="displayCenter">
                  <img class="tree_image_style" src="../assets/imgs/course/ICON/KM.png" alt="">
                  {{item.courseName}}
                </span>
                <a-tree-node v-for="val in item.children" :key="val.type">
                  <span slot="title"  @click="openTreeFn(val.type)" class="displayCenter"><img class="tree_image_style" src="../assets/imgs/course/ICON/DY.png" alt="">{{val.typeName}}</span>
                  <a-tree-node v-for="el in val.unitList" :key="el.unitId">
                    <span slot="title" @click="openTreeFn(el.unitId,el)" class="displayCenter"><img class="tree_image_style" src="../assets/imgs/course/ICON/KC.png" alt="">{{el.unitName}}</span>
                    <a-tree-node v-for="al in el.mediaList" :key="al.mediaId">
                      <span slot="title" @click="openFileFn(al,el)" class="displayCenter">
                        <img v-if="getFileType(al.path) == 'pptx'" class="tree_image_style" src="../assets/imgs/course/ICON/ppt.png" alt="">
                        <img v-else-if="getFileType(al.path) == 'doc'" class="tree_image_style" src="../assets/imgs/course/ICON/word.png" alt="">
                        <img v-else-if="getFileType(al.path) == 'mp4' || getFileType(al.path) == 'avi'" class="tree_image_style" src="../assets/imgs/course/ICON/video.png" alt="">
                        <img v-else class="tree_image_style" src="../assets/imgs/course/ICON/qt.png" alt="">
                        {{al.mediaName}}
                      </span>
                    </a-tree-node>
                  </a-tree-node>
                </a-tree-node>
              </a-tree-node>
          </a-tree>
      </div>
    </div>
    <div class="flexFileBox" :class="{'flexFileBoxActive':rightFileBoxStatus,'flexFileMenuBoxActive':menuStatus && !rightFileBoxStatus}">
      <div class="operateBox" style="background:#f9fafb">
        <div class="operateList" @click="$router.push({path:'/course/index'})"> <a-tooltip placement="bottom" title="回到科目"><i class="iconfont">&#xe751;</i></a-tooltip></div>
        <div class="operateList" v-if="!menuStatus" @click="menuStatus=true"> <a-tooltip placement="bottom" title="打开侧栏"><i class="iconfont" style="font-size:20px">&#xe630;</i></a-tooltip></div>
        <div class="operateList" style="float:right" @click="handleLogout"> <a-tooltip placement="bottom" title="退出登录"><i class="iconfont" style="font-size:20px">&#xe611;</i></a-tooltip></div>
      </div>
       <div class="iframeBox" >
        <div class="loadingBox" v-if="!unit_file_load"><a-spin   tip="努力加载文档中..."  /></div>
        <iframe v-show="unit_file_load && unitFileObj.fileUrl" style="width:100%;height:100%;overflow:hidden" @load="unit_file_load=true" :src="unitFileObj.fileUrl" frameborder="0"></iframe>
        <div v-show="unit_file_load && !unitFileObj.fileUrl" class="NofileUrl">未上传教案</div>
      </div>
    </div>
    <div class="rightFileBox" :class="{'rightFileBoxActive':rightFileBoxStatus}">
      <div class="operateBox " v-if="rightFileBoxStatus">
        <div class="operateList" style="float:right" @click="rightFileBoxStatus=false,mediaFileObj={}"> <a-tooltip placement="bottom" title="关闭"><i class="iconfont">&#xe61e;</i></a-tooltip></div>
        <div class="operateList" style="float:right" v-if="mediaFileObj && ( getFileType(mediaFileObj.fileUrl) != 'mp4' && getFileType(mediaFileObj.fileUrl) != 'avi')" @click="openViewFn"> <a-tooltip placement="bottom" title="全屏"><i class="iconfont">&#xe63f;</i></a-tooltip></div>
      </div>
      <div class="iframeBox iframeBoxRight" style="background:#fff">
         <template v-if="mediaFileObj && ( getFileType(mediaFileObj.fileUrl) == 'mp4' || getFileType(mediaFileObj.fileUrl) == 'avi')">
          <video ref="videoPlayer" controls style="width:100%" :src="mediaFileObj.path" />
        </template>
        <template v-else>
          <div class="loadingBox" v-if="!media_file_load"><a-spin   tip="努力加载文档中..."  /></div>
          <iframe v-show="media_file_load" style="width:100%;height:100%;overflow:hidden" @load="media_file_load=true" :src="mediaFileObj.fileUrl" frameborder="0"></iframe>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { getAction,postAction,getFilePrevew } from "@/api/manage";
import { mapActions } from "vuex";
export default {
  name: "CourseUnitModel",
  components: {},
  data() {
    return {
      menuStatus:false,
      rightFileBoxStatus:false,
      treeData:[],
      replaceFields:{},
      defaultExpandedKeys:[],
      courseObj:{},
      expandedKeys:[],
      mediaFileObj:{},
      media_file_load:false,
      unitFileObj:{},
      unit_file_load:false,
      courseId:this.$route.query.courseId67bn 
    };
  },
  created() {
    this.teachingCourse()
    // if(!this.$route.query.courseId){
      
    // }
  },
  mounted() {},
  methods: {
    ...mapActions(["Logout"]),
    // 获取是否有默认信息
    getKeyData(){
      getAction('/common/utils/getKey?key=courseInfo').then(res=>{
        if(res.code == 200){
          let data = JSON.parse(res.result)
          if(this.$route.query.courseId == data.courseId){
            
          }else{
            this.courseId = data.courseId
            this.expandedKeys = data.expandedKeys
            this.onSelect(data.courseId)
          }
        }else{

        }
      })
    },
    setKeyData(){
      postAction(`/common/utils/setKey?key=courseInfo`,{courseId:this.courseId,unitFileObj:this.unitFileObj,expandedKeys:this.expandedKeys}).then(res=>{
        if(res.code == 200){
          
        }
      })
    },
    // 获取科目
    teachingCourse(){
      let _this = this
      getAction('/teaching/teachingCourse/showCourse',{pageSzie:999}).then(res=>{
        if(res.success){
          this.treeData = res.result.records
          if(_this.$route.query.courseId){
            let item = res.result.records.find(ele=>ele.id == _this.$route.query.courseId)
            _this.onSelect(item.id)
          }else{
            _this.getKeyData()
          }
        }
      })
    },
    onSelect(id){
        this.courseId = id
         let index = this.expandedKeys.indexOf(id)
         let item = this.treeData.find(ele=> ele.id == id)
          if(index != -1){
            this.expandedKeys=[]
          }else{
            this.expandedKeys=[]
            this.expandedKeys.push(id)
          }
        let _this = this
        getAction('/teaching/teachingCourseUnit/myCourseUnitTreeWithType?courseId=' + id).then(res=>{
            if(res.success){
              
              if(res.result.typeList.length > 0){
                this.$set(item, 'children', res.result.typeList);
                _this.$forceUpdate()
                for (const ele of res.result.typeList) {
                for (const val of ele.unitList) {
                  if (val.unitNotes) {
                    val.fileUrl = this.setFileUrlFn(val.unitNotes);
                    _this.unitFileObj = val;
                    break; // 停止当前内层循环
                  }
                }
                if (_this.unitFileObj) {
                  break; // 停止外层循环
                }
              }
              _this.$nextTick(()=>{
                _this.setKeyData()
              })
              }else{
                _this.$message.error('请上传教案或者课件!')
              }
              
            }else{
              
            }
        })
    },
    openTreeFn(val,el){
      if(el != undefined){
         el.fileUrl = el.unitNotes ? this.setFileUrlFn(el.unitNotes) : '';
         this.unitFileObj = el;
      }
      let index = this.expandedKeys.indexOf(val)
      if(index != -1){
        this.expandedKeys.splice(index,1)
      }else{
        this.expandedKeys.push(val)
      }
    },
    openFileFn(item,unitObj){
      if(item.mediaType == 12){
        window.open(item.path)
        return;
      }
      this.media_file_load = false
      if(unitObj.unitId != this.unitFileObj.unitId){
        this.unit_file_load = false

        unitObj.fileUrl = unitObj.unitNotes ? this.setFileUrlFn(unitObj.unitNotes) : ''
        this.unitFileObj = unitObj
      }
      item.fileUrl = this.setFileUrlFn(item.path)
      this.mediaFileObj = item
      this.rightFileBoxStatus = true
    },
    openViewFn(){
      window.open(this.mediaFileObj.fileUrl,'_blank')
      this.rightFileBoxStatus = false
    },
    openMenuFn(){

    },
    //设置文档展示地址
    setFileUrlFn(url){
      var fileUrl = ''
      if(this.getFileType(url) == 'pptx'){
        fileUrl = getFilePrevew(url)
      }else{
        fileUrl = "/preview/onlinePreview?url=" + encodeURIComponent(btoa(url))
      }
      return fileUrl
    },
    // 获取文档类型
    getFileType(url){
      var fileType = null
      if(url){
        const file = url.split(',')[0]
        const lastDotIndex = file.lastIndexOf('.');
        fileType = lastDotIndex !== -1 ? file.substring(lastDotIndex + 1) : ''
      }
     
      return fileType
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({name:'index'})
              window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    // 销毁播放器
    destroyVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.src = '';
        video.load();
        // 从 DOM 中移除 video 元素
        video.parentNode.removeChild(video);
      }
    }
  },
};
</script>
<style lang='less' scoped>
/deep/.my-photo{
  margin: 0 !important;
}
.displayCenter{
  display: flex;
  align-items: center;
}
.loadingBox{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tree_image_style{
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
/deep/.ant-tree li{
  overflow: hidden; /* 隐藏超出容器宽度的部分 */
  white-space: nowrap; /* 禁止文字换行 */
}
.CourseUnitModel {
  width: 100vw;
  height: 100vh;
  background: #f3f4f6;
  overflow: hidden;
  
  .menuListBox{
    width: 320px;
    height: 100%;
    border-radius: 20px;
    box-shadow: 0 0 5px #ccc;
    background: #fff;
    position: fixed;
    top: 0;
    left: -330px;
    z-index: 99;
    transition: left 0.3s linear;
    overflow: hidden;
    .menuList{
      width: 100%;
      padding: 10px;
      height: calc(100% - 60px);
      overflow-y:auto;
    }
    .courseTitle{
      font-size: 18px;
      color: #333;
    }
  }
  .menuListBoxActive{
    left: 5px !important;
  }

  .flexFileBox{
    float: left;
    width: 100%;
    height: 100%;
    transition: all 0.3s linear;
  }
  .flexFileBoxActive{
    width: 60% !important;
  }
  .flexFileMenuBoxActive{
    width: calc(100% - 325px) !important;
    margin-left:325px !important;
  }
  .rightFileBox{
    float: right;
    width: 0%;
    height: 100%;
    transition: all 0.3s linear;
    box-shadow: 0 0 5px #e6e6e6;
  }
  .rightFileBoxActive{
    width: 40% !important;
  }
  .operateBox{
    width: 100%;
    height: 40px;
    padding: 0 10px;
    font-size: 24px;
    background: #fff;
    // display: flex;
    // align-items: center;
    color: #666;
    p{margin: 0;}
    .operateList{
      width: 40px;
      height: 40px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      float: left;
      .iconfont{
        font-size: 22px;
      }
    }
  }
  .iframeBox{
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    align-items: center;
  }
  .iframeBoxRight{
    box-shadow: 0 0 5px #f1f1f1;
  }
  .NofileUrl{
    width: 100%;
    height: 100%;
    font-size: 30px;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>
